module.exports = __webpack_public_path__ + "static/media/gal-14.81c07ab0.jpeg";